export default {
  'openPlatform.common.refresh': 'Refresh',
  'openPlatform.common.viewAll': 'View all',
  'openPlatform.common.details': 'View details',
  'openPlatform.common.success': 'Success',
  'openPlatform.common.failure': 'Failed',
  'openPlatform.common.enabled': 'Enabled',
  'openPlatform.common.disabled': 'Disabled',
  'openPlatform.common.cancel': 'Cancel',
  'openPlatform.common.close': 'Close',
  'openPlatform.common.noData': 'None',
  'openPlatform.workbench.title': 'Workbench',
  'openPlatform.workbench.loadFailed':
    'Failed to load the Open Platform workbench',
  'openPlatform.workbench.manageApplications': 'Manage applications',
  'openPlatform.workbench.totalApplications': 'Applications',
  'openPlatform.workbench.activeApplications': 'Active applications',
  'openPlatform.workbench.boundMembers': 'Bound members',
  'openPlatform.workbench.pendingBindings': 'Pending bindings',
  'openPlatform.workbench.callsLast24Hours': 'Calls in 24 hours',
  'openPlatform.workbench.failedCallsLast24Hours': 'Failures in 24 hours',
  'openPlatform.workbench.pendingAlert': '{count} binding requests are pending',
  'openPlatform.workbench.failedAlert':
    '{count} API calls failed in the past 24 hours',
  'openPlatform.workbench.applicationOverview': 'Application overview',
  'openPlatform.workbench.emptyApplications': 'No enterprise applications',
  'openPlatform.workbench.boundMemberCount': '{count} bound members',
  'openPlatform.workbench.recentCalls': 'Recent API calls',
  'openPlatform.workbench.emptyCalls': 'No API call records',
  'openPlatform.workbench.time': 'Time',
  'openPlatform.workbench.application': 'Application',
  'openPlatform.workbench.operation': 'Operation',
  'openPlatform.workbench.result': 'Result',
  'openPlatform.workbench.tokenExchange': 'Get token',
  'openPlatform.workbench.contextResolve': 'Resolve context',
  'openPlatform.keys.title': 'Applications',
  'openPlatform.keys.loadFailed': 'Failed to load applications',
  'openPlatform.keys.permissionLoadFailed':
    'Failed to load application permissions',
  'openPlatform.keys.selectPermission': 'Select permissions to authorize',
  'openPlatform.keys.authorizeSuccess': 'Application permissions authorized',
  'openPlatform.keys.authorizeFailed':
    'Failed to authorize application permissions',
  'openPlatform.keys.updateSuccess': 'Application updated',
  'openPlatform.keys.updateFailed': 'Failed to update application',
  'openPlatform.keys.createFailed': 'Failed to create application',
  'openPlatform.keys.create': 'Create application',
  'openPlatform.keys.empty': 'No applications',
  'openPlatform.keys.edit': 'Edit application',
  'openPlatform.keys.rotateSecret': 'Reset SecretKey',
  'openPlatform.keys.deleteConfirm':
    'The application will stop working immediately after deletion',
  'openPlatform.keys.delete': 'Delete application',
  'openPlatform.keys.identifier': 'Application identifier',
  'openPlatform.keys.tokenLifetime': 'Token lifetime',
  'openPlatform.keys.tokenLifetimeSeconds': '{seconds} seconds',
  'openPlatform.keys.permissions': 'Permissions',
  'openPlatform.keys.permissionManagement': 'Manage permissions',
  'openPlatform.keys.callbackUris': 'Member binding callback URLs',
  'openPlatform.keys.applicationName': 'Application name',
  'openPlatform.keys.applicationNameRequired': 'Enter an application name',
  'openPlatform.keys.applicationNamePlaceholder': 'Example: Ticketing SaaS',
  'openPlatform.keys.tokenLifetimeLabel': 'Token lifetime (seconds)',
  'openPlatform.keys.callbackUrisRequired': 'Enter one callback URL per line',
  'openPlatform.keys.credentialOnce':
    'Application credentials are shown only once',
  'openPlatform.keys.saved': 'I have saved them',
  'openPlatform.keys.accessKey': 'Application identifier / AccessKey',
  'openPlatform.keys.authorize': 'Authorize',
  'openPlatform.keys.authorizedPermissions': 'Authorized permissions',
  'openPlatform.keys.noAuthorizedPermissions':
    'This application has no authorized permissions',
  'openPlatform.keys.availableResources': 'Available resources',
  'openPlatform.keys.selectAll': 'Select All',
  'openPlatform.keys.noAvailableResources':
    'No resources are available. Define resources first.',
  'openPlatform.detail.loadFailed': 'Failed to load application details',
  'openPlatform.detail.loading': 'Loading application details',
  'openPlatform.detail.updateSuccess': 'Application updated',
  'openPlatform.detail.updateFailed': 'Failed to update application',
  'openPlatform.detail.enableSuccess': 'Application enabled',
  'openPlatform.detail.disableSuccess': 'Application disabled',
  'openPlatform.detail.enableFailed': 'Failed to enable application',
  'openPlatform.detail.disableFailed': 'Failed to disable application',
  'openPlatform.detail.rotateSuccess': 'SecretKey rotated',
  'openPlatform.detail.rotateFailed': 'Failed to rotate SecretKey',
  'openPlatform.detail.permissionNoChange': 'Permissions did not change',
  'openPlatform.detail.permissionUpdateSuccess': 'Permissions updated',
  'openPlatform.detail.permissionUpdateFailed': 'Failed to update permissions',
  'openPlatform.detail.unlinkSuccess': 'Binding removed',
  'openPlatform.detail.unlinkFailed': 'Failed to remove binding',
  'openPlatform.detail.notFound': 'Application not found',
  'openPlatform.detail.title': 'Application details',
  'openPlatform.detail.unnamedApplication': 'Unnamed application',
  'openPlatform.detail.secretStatus': 'SecretKey status',
  'openPlatform.detail.secretConfigured': 'Configured',
  'openPlatform.detail.rotate': 'Rotate',
  'openPlatform.detail.tenant': 'Enterprise',
  'openPlatform.detail.creator': 'Created by',
  'openPlatform.detail.createdAt': 'Created at',
  'openPlatform.detail.status': 'Status',
  'openPlatform.detail.recentCall': 'Latest API call',
  'openPlatform.detail.bindingCount': 'Bound members',
  'openPlatform.detail.applicationId': 'Application ID',
  'openPlatform.detail.callbackSection': 'Callback URLs',
  'openPlatform.detail.noCallbackUris': 'No callback URLs configured',
  'openPlatform.detail.savePermissions': 'Save permissions',
  'openPlatform.detail.bindings': 'Bound members',
  'openPlatform.detail.member': 'Zhiyue member',
  'openPlatform.detail.memberAccount': 'Member account',
  'openPlatform.detail.memberUuid': 'Member UUID',
  'openPlatform.detail.boundAt': 'Bound at',
  'openPlatform.detail.lastUsedAt': 'Last used at',
  'openPlatform.detail.unlink': 'Remove binding',
  'openPlatform.detail.unlinkConfirm':
    'This binding will stop working after removal',
  'openPlatform.detail.editTitle': 'Edit application',
  'openPlatform.detail.secretOnce': 'SecretKey is shown only once',
  'openPlatform.detail.secretMissing':
    'The server did not return a new SecretKey',
  'openPlatform.callLogs.title': 'API Call Logs',
  'openPlatform.callLogs.loadFailed': 'Failed to load API call logs',
  'openPlatform.callLogs.empty': 'No API call logs',
  'openPlatform.callLogs.callTime': 'Call time',
  'openPlatform.callLogs.operation': 'Operation',
  'openPlatform.callLogs.endpoint': 'Endpoint',
  'openPlatform.callLogs.applicationIdentifier': 'Application identifier',
  'openPlatform.callLogs.memberUuid': 'Member UUID',
  'openPlatform.callLogs.requiredScope': 'Required permission',
  'openPlatform.callLogs.statusCode': 'Status code',
  'openPlatform.callLogs.duration': 'Duration',
  'openPlatform.callLogs.result': 'Result',
  'openPlatform.callLogs.enterpriseCall': 'Enterprise-level call',
  'openPlatform.callLogs.notSpecified': 'Not specified',
  'openPlatform.binding.invalidUrl': 'Invalid binding URL',
  'openPlatform.binding.expired':
    'The binding request has expired or was completed',
  'openPlatform.binding.notFound': 'Binding request not found',
  'openPlatform.binding.validateFailed':
    'Failed to validate the binding request',
  'openPlatform.binding.validating': 'Validating the binding request...',
  'openPlatform.binding.returnToThirdParty':
    'Return to third-party application',
  'openPlatform.binding.back': 'Go back',
  'openPlatform.binding.unavailable': 'Unable to bind account',
  'openPlatform.binding.notLoggedInTitle': 'Sign in to Zhiyue',
  'openPlatform.binding.notLoggedInDescription':
    'Sign in with a Zhiyue account that belongs to this enterprise before authorizing “{appName}”.',
  'openPlatform.binding.login': 'Sign in to Zhiyue',
  'openPlatform.binding.cancelAndReturn': 'Cancel and return',
  'openPlatform.binding.bindingTitle': 'Bind your Zhiyue account',
  'openPlatform.binding.bindingDescription':
    '“{appName}” is requesting access to your Zhiyue account in this enterprise. After binding, it can perform authorized operations on your behalf.',
  'openPlatform.binding.currentAccount': 'Current account',
  'openPlatform.binding.switchAccount': 'Switch account',
  'openPlatform.binding.requestedScopes': 'Requested API permissions:',
  'openPlatform.binding.expiresAt': 'Binding request expires at {expiresAt}',
  'openPlatform.binding.confirm': 'Confirm binding and authorize',
  'openPlatform.binding.conflict':
    'This Zhiyue member is already bound to another third-party user',
  'openPlatform.binding.forbidden':
    'The signed-in account does not belong to the enterprise that owns this application',
  'openPlatform.binding.confirmFailed': 'Failed to confirm binding',
  'openPlatform.binding.unnamedApplication': 'Enterprise application',
};
